// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"SurveyJsPlayerWidget_editorContainer__3-Smf"};